import { Component, OnInit } from '@angular/core';
import { TableTradeService } from '@pg-app/client/client-dashboard/components/tables/table.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { format } from 'date-fns';
import { UtilityService } from '@nttp/common-service/utility-service';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { ToastrService } from 'ngx-toastr';
import { SortTypeEnum } from '@pg-app/shared/enums/sort-type.enum';
import { DownloadFileTypeEnum } from '@nttp/enum/download-file-type-enum';

@Component({
  selector: 'np-download-history-trade',
  templateUrl: './download-history-trade.component.html',
  styleUrls: ['./download-history-trade.component.scss']
})
export class DownloadHistoryTradeComponent implements OnInit {
  downloadTrade: FormGroup;

  public rows: Array<any> = [];
  columns = [
      {
        title: 'Creation date',
        name: 'creationDate',
        type: TableCellTypes.Date,
        width: '130px'
      },
      {
        title: 'Trade reference',
        name: 'tradeNumber',
        width: '120px'
      },
      {
        title: 'User',
        name: 'user',
        width: '100px'
      },
      {
        title: 'Trade type',
        name: 'tradeType',
        width: '110px'
      },
      {
        title: 'Value date',
        name: 'valueDate',
        type: TableCellTypes.Date,
        width: '130px'
      },
      {
        title: 'Sell Currency and Amount',
        name: 'sellAmount',
        class: 'text-right',
        width: '180px'
      },
      {
        title: 'Buy Currency and Amount',
        name: 'buyAmount',
        class: 'text-right',
        width: '180px'
      },
      {
        title: 'Rate',
        name: 'rate',
        type: TableCellTypes.Rate,
        class: 'text-right',
        width: '160px'
      }
    ];

  today = new Date();

  types = [
    {
      id: 3,
      name: 'Settled'
    },
    {
      id: 1,
      name: 'Outstanding'
    },
    {
      id: 0,
      name: 'Both'
    }
  ];

  get startDateCtrl(): FormControl {
    return this.downloadTrade.get('startDate') as FormControl;
  }
  get endDateCtrl(): FormControl {
    return this.downloadTrade.get('endDate') as FormControl;
  }
  get tradeStatusCtrl(): FormControl {
    return this.downloadTrade.get('tradeStatus') as FormControl;
  }

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private tableTradeService: TableTradeService,
    private utilityService: UtilityService,
    public dialogRef: MatDialogRef<DownloadHistoryTradeComponent>,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.downloadTrade = this.fb.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      tradeStatus: [1, Validators.required]
    });
  }

  public onDblCellClick(trade: any) {
    const params = {
      leadId: null,
      tradeNumber: trade.row.number
    };
    this.tableTradeService.downloadPDF(params).subscribe(data => {
      const fileName = `Trade_${trade.row.tradeNumber}.pdf`;
      this.utilityService.downloadFile(data, fileName, DownloadFileTypeEnum.PDF);
    });
  }

  public getTrades() {
    const tableData = {
      fromDate: format(this.startDateCtrl.value, 'YYYYMMDD'),
      toDate: format(this.endDateCtrl.value, 'YYYYMMDD'),
      state: this.tradeStatusCtrl.value || null,
      isExportExcel: false,
      getAll: true,
      sortName: 'CreationDate',
      sortType: SortTypeEnum.Desc,
    };

    this.tableTradeService.getTradeByState(tableData).subscribe(
      response => {
        this.rows = response?.trades || [];
    });
  }

  public getSearchDataTable() {
    if (!this.downloadTrade.valid) {
      return;
    }

    if (new Date(this.startDateCtrl.value) > new Date(this.endDateCtrl.value)) {
      this.toastr.error(`From date should not be greater than To date`);
      return;
    }

    this.getTrades();
  }

  togglePicker(picker) {
    picker.opened ? picker.close() : picker.open();
  }

  exportExcel() {
    if (!this.downloadTrade.valid) {
      return;
    }

    if (new Date(this.startDateCtrl.value) > new Date(this.endDateCtrl.value)) {
      this.toastr.error(`From date should not be greater than To date`);
      return;
    }

    const params = {
      fromDate: format(this.startDateCtrl.value, 'YYYYMMDD'),
      toDate: format(this.endDateCtrl.value, 'YYYYMMDD'),
      state: this.tradeStatusCtrl.value || null,
      isExportExcel: true
    };
    const x = this.types.find(item => item.id === this.tradeStatusCtrl.value);
    this.tableTradeService.exportExcel(params).subscribe(data => {
      const fileName = `${x.name}_Trade_${format(this.startDateCtrl.value, 'DDMMYYYY')}_${format(
        this.endDateCtrl.value,
        'DDMMYYYY'
      )}.xlsx`;
      this.utilityService.downloadFile(data, fileName, DownloadFileTypeEnum.Excel);
    });
  }

  close() {
    this.dialogRef.close();
  }
}
